  export interface FormData {
    name: string;
    documentType: string;
    documentNumber: string;
    email: string;
    password: string;
    confirmPassword: string;
  }
  
  export interface FormErrors {
    name?: string;
    documentNumber?: string;
    email?: string;
    password?: string;
    confirmPassword?: string;
  }

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePassword = (password: string): boolean => {
    // Mínimo 8 caracteres, al menos una mayúscula, una minúscula y un número
    return password.length >= 8;
  };

  export const validateForm = ({formData, setFormErrors}: { formData: FormData, setFormErrors: React.Dispatch<React.SetStateAction<FormErrors>> }): boolean => {
    const errors: FormErrors = {};

    // Validar nombre
    if (!formData.name.trim()) {
      errors.name = "El nombre es obligatorio";
    } else if (formData.name.trim().length < 3) {
      errors.name = "El nombre debe tener al menos 3 caracteres";
    }

    // Validar documento
    if (!formData.documentNumber.trim()) {
      errors.documentNumber = "El número de documento es obligatorio";
    } else if (!/^\d+$/.test(formData.documentNumber)) {
      errors.documentNumber = "El documento solo debe contener números";
    }

    // Validar email
    if (!formData.email.trim()) {
      errors.email = "El email es obligatorio";
    } else if (!validateEmail(formData.email)) {
      errors.email = "Ingrese un email válido";
    }

    // Validar contraseña
    if (!formData.password) {
      errors.password = "La contraseña es obligatoria";
    } else if (!validatePassword(formData.password)) {
      errors.password = "La contraseña debe tener al menos 8 caracteres";
    }

    // Validar confirmación de contraseña
    if (!formData.confirmPassword) {
      errors.confirmPassword = "Debe confirmar la contraseña";
    } else if (formData.password !== formData.confirmPassword) {
      errors.confirmPassword = "Las contraseñas no coinciden";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };